import './DesktopCompanyCustomerLoginForm.scss'

import { ErrorMessage, FieldTextV6, Spinner } from '@tallink/components-lib'
import { mediaQueries } from '@tallink/components-lib/src/constants/media'
import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useMedia } from 'react-use'

import {
  companyLoggedIn,
  getCompanyInfo,
  getSerialTickets,
  updateCompanyIdFieldValue
} from '../../../../../actions/actions'
import { getCompany } from '../../../../../selectors/selectors'
import SubmitButton from './SubmitButton/SubmitButton'

export default function DesktopCompanyCustomerLoginForm() {
  const { t } = useTranslation()
  const { companyIdFieldValue } = useSelector(getCompany)
  const { register, handleSubmit, errors, setError, formState, watch } = useForm({
    defaultValues: { companyId: companyIdFieldValue },
    mode: 'onChange'
  })
  const mdUp = useMedia(mediaQueries.mdUp, true)
  const errorComponent = errors.companyId?.type === 'manual' && <ErrorMessage message={errors.companyId.message} />
  const companyInputValue = watch('companyId')
  const dispatch = useDispatch()

  return (
    <>
      <form className="company-customer-login-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="input-with-spinner-container">
          <FieldTextV6
            className="company-input"
            disabled={formState.isSubmitting}
            inputRef={register({ pattern: { value: /^\d{1,6}$/ } })}
            invalid={errors.companyId?.type === 'pattern'}
            name="companyId"
            onChange={e => dispatch(updateCompanyIdFieldValue(e.target.value))}
            placeholder={t('companyCustomer.id')}
            size="s"
          />
          {formState.isSubmitting && <Spinner className="spinner" />}
        </div>
        {!mdUp && errorComponent}
        <SubmitButton disabled={!companyInputValue || !!errors.companyId || formState.isSubmitting}>
          {t('companyCustomer.login')}
        </SubmitButton>
      </form>
      {mdUp && errorComponent}
    </>
  )

  async function onSubmit({ companyId }) {
    const companyInfo = await getCompanyInfo(companyId)
    if (companyInfo.valid) {
      dispatch(companyLoggedIn({ companyId, ...companyInfo }))
      dispatch(getSerialTickets())
    } else setError('companyId', { type: 'manual', message: t('companyCustomer.error') })
  }
}
